import { GlSkeletonLoader } from '@gitlab/ui';
export default {
    name: 'PackageHistoryLoader',
    components: {
        GlSkeletonLoader
    }
};
